import { getUnitConversions, getUnits } from './http/unit';
import Units from '@protoplan/unit-utils/lib/Units';


const units = new Units(getUnits, getUnitConversions);

export default units;